module.exports = __webpack_public_path__ + "static/img/login-bghx.11e1764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bghx.jpg
// module id = ybHq
// module chunks = 1